<template>
  <div class="invoice-box">
    <table cellpadding="0" cellspacing="0">
      <tr class="top">
        <td colspan="8" style="padding-bottom: 2rem">
          <table>
            <tr>
              <td class="title">
                <img
                  v-if="invoiceLogo"
                  :src="`data:image/png;base64, ${invoiceLogo}`"
                  style="width: auto; max-width: 300px; max-height: 150px"
                  alt=""
                />
              </td>
              <td>
                <span class="header-type">
                  <template v-if="invoiceType === 'factura'">
                    Factura
                  </template>
                  <template v-else-if="invoiceType === 'presupuesto'">
                    Presupuesto
                  </template>
                </span>
                <br />
                <h1 class="header-code">{{ invoice.code }}</h1>
                <br />
                <span class="header-date">{{ `Fecha: ${formattedInvoiceDate}` }}</span>
                <br />
                <span class="header-due-date" v-if="invoice.expiration_date">
                  {{ `F. Vencimiento: ${formattedInvoiceExpirationDate}` }}
                </span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="information">
        <td colspan="8">
          <table>
            <tr>
              <td>
                <template v-if="invoice.openbilling_profile_id">
                  <span>
                    <strong>{{ `${invoice.profile_name}` }}</strong>
                  </span>
                  <br />
                  <span>{{ `${invoice.profile_cif}` }}</span>
                  <br />
                  <span>{{ `${invoice.profile_address}` }}</span>
                  <br />
                  <span>
                    {{
                      `${invoice.profile_postal_code} ${invoice.profile_city} (${
                        invoice.profile_province
                      })`
                    }}
                  </span>
                  <br />
                  <span>
                    {{ `${invoice.profile_country}` }}
                  </span>
                  <template v-if="invoice.profile_email">
                    <br />
                    <span>{{ `${invoice.profile_email}` }}</span>
                  </template>
                  <template v-if="invoice.profile_phone">
                    <br />
                    <span>{{ `${invoice.profile_phone}` }}</span>
                  </template>
                </template>
                <template v-else>
                  <span>
                    <strong>{{ `${currentProfile ? currentProfile.name : ''}` }}</strong>
                  </span>
                  <br />
                  <span>{{ `${currentProfile ? currentProfile.cif : ''}` }}</span>
                  <br />
                  <span>{{ `${currentProfile ? currentProfile.address : ''}` }}</span>
                  <br />
                  <span>
                    {{
                      `${currentProfile ? currentProfile.postal_code : ''}
                       ${currentProfile ? currentProfile.city : ''} (${
                        currentProfile ? currentProfile.province : ''
                      })`
                    }}
                  </span>
                  <br />
                  <span>
                    {{ `${currentProfile ? currentProfile.country : ''}` }}
                  </span>
                  <template v-if="currentProfile && currentProfile.email">
                    <br />
                    <span>{{ `${currentProfile.email}` }}</span>
                  </template>
                  <template v-if="currentProfile && currentProfile.phone">
                    <br />
                    <span>{{ `${currentProfile.phone}` }}</span>
                  </template>
                </template>
              </td>

              <td>
                <template v-if="invoice.openbilling_contact_id || invoice.contact_name">
                  <span>
                    <strong>{{ `${invoice.contact_name}` }}</strong>
                  </span>
                  <br />
                  <span>{{ `${invoice.contact_cif}` }}</span>
                  <br />
                  <span>{{ `${invoice.contact_address}` }}</span>
                  <br />
                  <span>
                    {{
                      `${invoice.contact_postal_code} ${invoice.contact_city} (${
                        invoice.contact_province
                      })`
                    }}
                  </span>
                  <br />
                  <span>
                    {{ `${invoice.contact_country}` }}
                  </span>
                  <template v-if="invoice.contact_email">
                    <br />
                    <span>{{ `${invoice.contact_email}` }}</span>
                  </template>
                  <template v-if="invoice.contact_phone">
                    <br />
                    <span>{{ `${invoice.contact_phone}` }}</span>
                  </template>
                </template>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="heading">
        <td style="width: 50%">Concepto</td>
        <td>Precio Ud.</td>
        <td>Cant.</td>
        <td>Dto.</td>
        <td>Impuesto</td>
        <!--<td>IRPF</td>-->
        <td>Total</td>
      </tr>
      <template v-for="(item, index) in invoice.order_items">
        <tr class="item" :class="{ 'has-detail': item.detail && item.detail.trim() }" :key="index">
          <td
            style="text-align: left; width: 50%; white-space: pre-line"
            v-text="item.description"
          ></td>
          <td>{{ item.tax_base }} €</td>
          <td>{{ item.quantity }}</td>
          <td>
            {{ calculateItemDiscount(item) }}
            <br />
            {{
              item.discount_type === 'percentage' && item.discount_amount > 0
                ? `(${item.discount_amount}%)`
                : ''
            }}
          </td>
          <td>
            <template v-if="item.type === 'suplido'">
              Suplido
            </template>
            <template v-else-if="item.tax === null">
              Exento de
              <br />
              IVA/IGIC
            </template>
            <template v-else>
              <!--{{ parseAmount(item.tax_amount) }}
              <br />
              {{ `(${item.tax}%)` }}-->
              {{ `${item.tax}%` }}
            </template>
          </td>
          <!--<td>
            {{ parseAmount(item.irpf_amount) }}
            <br />
            {{ item.irpf ? `(-${item.irpf}%)` : '' }}
          </td>-->
          <td>{{ parseAmount(item.total_amount_with_taxes) }}</td>
        </tr>
        <tr v-if="item.detail && item.detail.trim()" class="item" :key="`detail-${index}`">
          <td
            colspan="6"
            style="text-align: left; white-space: pre-line; padding-top: 0"
            v-html="invoiceLineDetailToHtml(item.detail)"
          ></td>
        </tr>
      </template>
      <tr>
        <td colspan="2"></td>
        <td colspan="6">
          <table style="margin-top: 2rem">
            <template
              v-if="
                (!totalInvoiceData.totalTaxIVABase && !totalInvoiceData.totalTaxIGICBase) ||
                  (!totalInvoiceData.totalTaxIVABase &&
                    totalInvoiceData.totalTaxIGICBase !== totalInvoiceData.totalTaxBase) ||
                  (!totalInvoiceData.totalTaxIGICBase &&
                    totalInvoiceData.totalTaxIVABase !== totalInvoiceData.totalTaxBase)
              "
            >
              <tr>
                <td style="text-align: left">
                  <span style="font-weight: bold">Base Imponible</span>
                </td>
                <td style="text-align: right">
                  <span style="font-weight: bold">
                    {{ parseAmount(totalInvoiceData.totalTaxBase) }}
                  </span>
                </td>
              </tr>
            </template>
            <!-- IVA Summary -->
            <template v-if="totalInvoiceData.totalTaxIVABase">
              <tr>
                <td style="text-align: left">
                  <span style="font-weight: bold">
                    {{
                      totalInvoiceData.totalTaxIGICBase ? 'Base Imponible IVA' : 'Base Imponible'
                    }}
                  </span>
                </td>
                <td style="text-align: right">
                  <span style="font-weight: bold">
                    {{ parseAmount(totalInvoiceData.totalTaxIVABase) }}
                  </span>
                </td>
              </tr>
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax21">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 21%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax21.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax21">
                <td style="text-align: left"><span>IVA 21%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax21) }}</span>
                </td>
              </tr>
              <!-- 12% -->
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax12">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 12%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax12.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax12">
                <td style="text-align: left"><span>IVA 12%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax12) }}</span>
                </td>
              </tr>
              <!-- 10,5% -->
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax105">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 10,5%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax105.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax105">
                <td style="text-align: left"><span>IVA 10,5%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax105) }}</span>
                </td>
              </tr>
              <!-- 10% -->
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax10">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 10%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax10.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax10">
                <td style="text-align: left"><span>IVA 10%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax10) }}</span>
                </td>
              </tr>
              <!-- provisional tax -->
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax75">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 7,5%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax75.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax75">
                <td style="text-align: left"><span>IVA 7,5%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax75) }}</span>
                </td>
              </tr>
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax5">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 5%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax5.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax5">
                <td style="text-align: left"><span>IVA 5%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax5) }}</span>
                </td>
              </tr>
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax4">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 4%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax4.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax4">
                <td style="text-align: left"><span>IVA 4%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax4) }}</span>
                </td>
              </tr>
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax2">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 2%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax2.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax2">
                <td style="text-align: left"><span>IVA 2%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax2) }}</span>
                </td>
              </tr>
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax0">
                <tr>
                  <td style="text-align: left"><span>Base imponible IVA 0%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax0.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax0">
                <td style="text-align: left"><span>IVA 0%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax0) }}</span>
                </td>
              </tr>
            </template>
            <template v-if="totalInvoiceData.totalTaxIGICBase">
              <tr>
                <td style="text-align: left">
                  <span style="font-weight: bold">
                    {{
                      totalInvoiceData.totalTaxIVABase ? 'Base Imponible IGIC' : 'Base Imponible'
                    }}
                  </span>
                </td>
                <td style="text-align: right">
                  <span style="font-weight: bold">
                    {{ parseAmount(totalInvoiceData.totalTaxIGICBase) }}
                  </span>
                </td>
              </tr>
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax7">
                <tr>
                  <td style="text-align: left"><span>Base imponible IGIC 7%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax7.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax7">
                <td style="text-align: left"><span>IGIC 7%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax7) }}</span>
                </td>
              </tr>
              <template v-if="numberOfTaxes > 1 && totalInvoiceData.totalTax3">
                <tr>
                  <td style="text-align: left"><span>Base imponible IGIC 3%</span></td>
                  <td style="text-align: right">
                    <span>{{ parseAmount(itemsTax.tax3.base) }}</span>
                  </td>
                </tr>
              </template>
              <tr v-if="totalInvoiceData.totalTax3">
                <td style="text-align: left"><span>IGIC 3%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalTax3) }}</span>
                </td>
              </tr>
            </template>
            <template>
              <tr v-if="totalInvoiceData.totalIrpf19">
                <td style="text-align: left"><span>IRPF 19%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalIrpf19) }}</span>
                </td>
              </tr>
              <tr v-if="totalInvoiceData.totalIrpf15">
                <td style="text-align: left"><span>IRPF 15%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalIrpf15) }}</span>
                </td>
              </tr>
              <tr v-if="totalInvoiceData.totalIrpf7">
                <td style="text-align: left"><span>IRPF 7%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalIrpf7) }}</span>
                </td>
              </tr>
              <tr v-if="totalInvoiceData.totalIrpf2">
                <td style="text-align: left"><span>IRPF 2%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalIrpf2) }}</span>
                </td>
              </tr>
              <tr v-if="totalInvoiceData.totalIrpf1">
                <td style="text-align: left"><span>IRPF 1%</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalInvoiceData.totalIrpf1) }}</span>
                </td>
              </tr>
            </template>
            <template v-if="totalInvoiceData.totalDiscount">
              <tr>
                <td colspan="2">
                  <hr style="border: 1px dotted" />
                </td>
              </tr>
              <tr>
                <td style="text-align: left"><span>Descuentos aplicados</span></td>
                <td style="text-align: right">
                  <span>-{{ parseAmount(totalInvoiceData.totalDiscount) }}</span>
                </td>
              </tr>
            </template>
            <template v-if="totalSuplidos">
              <tr>
                <td colspan="2">
                  <hr style="border: 1px dotted" />
                </td>
              </tr>
              <tr>
                <td style="text-align: left"><span>Suplidos</span></td>
                <td style="text-align: right">
                  <span>{{ parseAmount(totalSuplidos) }}</span>
                </td>
              </tr>
            </template>
            <tr>
              <td colspan="2">
                <hr />
              </td>
            </tr>
            <tr>
              <td style="text-align: left">
                <span style="font-weight: bold">TOTAL</span>
              </td>
              <td style="text-align: right">
                <span style="font-weight: bold">
                  {{ parseAmount(totalInvoiceData.totalAmount) }}
                </span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <div class="invoice-info" v-if="invoice.payment_method || invoice.observations">
      <table>
        <tr class="heading">
          <td v-if="invoice.payment_method"><span>Método de pago</span></td>
          <td v-if="invoice.observations"><span>Observaciones</span></td>
        </tr>
        <tr class="details">
          <td v-if="invoice.payment_method">
            <span>{{ invoice.payment_method }}</span>
            <span v-if="invoice.payment_method === 'Transferencia'">
              - {{ invoice.account_iban }}
            </span>
          </td>
          <td v-if="invoice.observations">
            <span>{{ invoice.observations }}</span>
          </td>
        </tr>
      </table>
    </div>

    <div class="invoice-info" v-if="invoiceFooter">
      <table>
        <tr class="details invoice-footer">
          <td>
            <span>{{ invoiceFooter }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apiCtrl from '@/services/api/abstract/abstract-api';
import { invoiceLineDetailToHtml } from '@/modules/openbilling/helpers/invoiceLineDetail';
export default {
  name: 'OpenBillingInvoicePreview',
  components: {},
  props: [
    'invoice',
    'totalInvoiceData',
    'invoiceType',
    'logo',
    'itemsTax',
    'selectedTaxes',
    'totalSuplidos',
  ],
  data() {
    return {
      invoiceLogo: this.logo,
    };
  },
  computed: {
    formattedInvoiceDate() {
      return this.invoice.date ? moment(this.invoice.date).format('DD/MM/YYYY') : '';
    },
    formattedInvoiceExpirationDate() {
      return this.invoice.expiration_date
        ? moment(this.invoice.expiration_date).format('DD/MM/YYYY')
        : '';
    },
    currentProfile() {
      return this.$store.getters.currentOpenbillingProfile;
    },
    invoiceFooter() {
      return this.currentProfile ? this.currentProfile.invoice_footer : null;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
    numberOfTaxes() {
      let numberOfTaxes = 0;
      const taxes = Object.entries(this.selectedTaxes);
      taxes.forEach(([key, value]) => {
        if (value === true) {
          numberOfTaxes = numberOfTaxes + 1;
        }
      });
      return numberOfTaxes;
    },
  },
  mounted() {
    console.log(this.itemsTax);
    if (!this.logo && this.currentProfile && this.currentProfile.logo) {
      // this.getLogoBase64();
    }
  },
  methods: {
    invoiceLineDetailToHtml,
    calculateItemDiscount(item) {
      let price = item.quantity * item.tax_base;
      let discount = 0;
      if (item.discount_amount) {
        discount =
          item.discount_type === 'percentage'
            ? (price * item.discount_amount) / 100
            : item.discount_amount;
      }
      return `-${parseFloat(discount)
        .toFixed(2)
        .replace('.', ',')} €`;
    },
    calculateItemTax(item) {
      let price = item.quantity * item.tax_base;
      if (item.discount_amount) {
        let discount =
          item.discount_type === 'percentage'
            ? (price * item.discount_amount) / 100
            : item.discount_amount;
        price = price - discount;
      }
      let tax = 0;
      tax = (price * item.tax) / 100;
      return `${parseFloat(tax)
        .toFixed(2)
        .replace('.', ',')} €`;
    },
    calculateItemIrpf(item) {
      let price = item.quantity * item.tax_base;
      if (item.discount_amount) {
        let discount =
          item.discount_type === 'percentage'
            ? (price * item.discount_amount) / 100
            : item.discount_amount;
        price = price - discount;
      }
      let irpf = 0;
      irpf = (price * item.irpf) / 100;
      return `${parseFloat(irpf)
        .toFixed(2)
        .replace('.', ',')} €`;
    },
    parseAmount(totalAmount) {
      let total = parseFloat(totalAmount);
      return `${parseFloat(total)
        .toFixed(2)
        .replace('.', ',')} €`;
    },
    getLogoBase64() {
      apiCtrl
        .get(`/openbilling/${this.clavedat}/settings/logo/${this.currentProfile.id}/base64`)
        .then(res => {
          this.invoiceLogo = res.data;
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.header-type {
  display: block;
  font-size: 1.7rem;
}
.header-code {
  display: block;
}
.header-date {
  background-color: rgba(0, 175, 168, 0.15);
  padding: 0.5rem;
  border-radius: 10px;
}
.header-due-date {
  display: block;
  margin-top: 0.5rem;
}

.invoice-box {
  max-width: 100%;
  margin: auto;
  padding: 30px;
  /*border: 1px solid #eee;*/
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  font-size: 12px;
  line-height: 24px;
  font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  /*background: #eee;*/
  background-color: rgba(0, 175, 168, 0.15);
  border-bottom: 1px solid #ddd;
  font-weight: bold;
  text-align: center;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
  text-align: center;
}

/* El detalle va en una fila a todo el ancho debajo de su línea */
.invoice-box table tr.item.has-detail td {
  border-bottom: none;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box .invoice-info table {
  margin-top: 15px;
}
.invoice-box .invoice-info tr.details td {
  text-align: left;
}
.invoice-box .invoice-info tr.heading td {
  background-color: rgba(0, 175, 168, 0.15);
  border-bottom: 1px solid #ddd;
  font-weight: bold;
  text-align: left;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

/** RTL **/
.invoice-box.rtl {
  direction: rtl;
  font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
}

.invoice-box.rtl table {
  text-align: right;
}

.invoice-box.rtl table tr td:nth-child(2) {
  text-align: left;
}

.invoice-footer {
  font-size: 9px;
  text-align: justify;
}
</style>
